<template>
  <BaseDrawer 
    ref="baseDrawer" 
    title="Add/Hide Columns"
    subtitle="Select or re-arrange columns to display"
  >
    <!-- <div class="w-full flex pr-4">
      <div 
        class="w-1/2 border-b-2 py-3 pr-3"
        :class="[studyTypeSelected == 'Existing Buildings' ? 'border-blue04 text-pri font-bold' : 'border-blue04-10 text-gray font-semi-bold']"
      >
        <button 
          @click="studyTypeSelected = 'Existing Buildings'"
          :class="[studyTypeSelected == 'Existing Buildings' ? 'border-blue04 text-blue02 font-bold' : 'border-blue04-10 text-gray font-semi-bold']"
          class="focus:outline-none"
        >Existing Buildings</button>
      </div>
      <div 
        class="w-1/2 border-b-2 py-3 px-3" 
        :class="[studyTypeSelected == 'New Buildings' ? 'border-blue04 text-pri font-bold' : 'border-blue04-10 text-gray font-semi-bold']"
      >
        <button 
          @click="studyTypeSelected = 'New Buildings'"
          :class="[studyTypeSelected == 'New Buildings' ? 'border-blue04 text-blue02 font-bold' : 'border-blue04-10 text-gray font-semi-bold']"
          class="focus:outline-none"
        >New Buildings</button>
      </div>
    </div> -->
    
    <DragAndDropEditColumnsList
      :get-columns="getColumns"
      module="policy"
    />
  </BaseDrawer>
</template>

<script>
import { randomString } from '@/util/Functions'
export default {
  name: 'DrawerPolicyEditColumns',
  data() {
    return {
      studyTypeSelected: 'Existing Buildings'
    }
  },

  computed: {
    getItemKey() {
      return randomString(10)
    },
    getColumns() {
      if(this.studyTypeSelected == 'New Buildings') {
        return this.$store.getters['policy/getterPolicyNewBuildingsColumns']
      }
      return this.$store.getters['policy/getterPolicyExistingBuildingsColumns']
    },

  },
  mounted() {
    this.$eventBus.$on('openDrawerPolicyEditColumns', (studyType) => {
      if (studyType) {
        this.studyTypeSelected = studyType 
      }
      this.$refs.baseDrawer.openDrawer()
    })
  },
  beforeDestroy() {
    this.$eventBus.$off('openDrawerPolicyEditColumns')
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep {
    &.app-drawer {
      width: 478px;
    }
  }
</style>
